var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 4H4.99982C4.20417 4 3.44111 4.31607 2.8785 4.87868C2.31589 5.44129 1.99982 6.20435 1.99982 7V17C1.99982 17.7956 2.31589 18.5587 2.8785 19.1213C3.44111 19.6839 4.20417 20 4.99982 20H18.9998C19.7955 20 20.5585 19.6839 21.1211 19.1213C21.6837 18.5587 21.9998 17.7956 21.9998 17V7C21.9998 6.20435 21.6837 5.44129 21.1211 4.87868C20.5585 4.31607 19.7955 4 18.9998 4ZM18.3298 6L11.9998 10.75L5.66982 6H18.3298ZM18.9998 18H4.99982C4.7346 18 4.48025 17.8946 4.29271 17.7071C4.10517 17.5196 3.99982 17.2652 3.99982 17V7.25L11.3998 12.8C11.5729 12.9298 11.7834 13 11.9998 13C12.2162 13 12.4267 12.9298 12.5998 12.8L19.9998 7.25V17C19.9998 17.2652 19.8945 17.5196 19.7069 17.7071C19.5194 17.8946 19.265 18 18.9998 18Z",
    fill: "#FC5027"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.f957a5096c110d3ec06e94680774a89e.svg";
export { ForwardRef as ReactComponent };